@let stopsMode = mode() === TopSearchDropdownItemMode.STOPS;
@let isMobile = isMobile$ | async;
@let selected = selected$ | async;
@let multiChoiceEnableScroll = !inlineLayout();
@let multiChoiceHeight = multiChoiceContainerHeight$ | async;
@let multiChoiceConstrainHeight = multiChoiceEnableScroll && !!multiChoiceHeight;
@let showFooterButtons = !inlineLayout() && (type !== DropdownType.COUNTER || isMobile);

<div class="dropdown-item">
	<div class="dropdown-item__content">
		@if (type === DropdownType.MULTI) {
			<div>
				@if (mode() === TopSearchDropdownItemMode.STOPS) {
					<div class="flex flex-col text-mainColor font-bold">
						Rodzaj transportu:
						<div class="grid w-full">
							<mat-checkbox
								(change)="updateTransportKind($event, TransportKind.COUCH)"
								value="coach"
								[(ngModel)]="selectedTransport().coach"
								>Autokarem</mat-checkbox
							>
							<mat-checkbox
								(change)="updateTransportKind($event, TransportKind.PLANE)"
								value="plane"
								[(ngModel)]="selectedTransport().plane"
								>Samolotem</mat-checkbox
							>
							<mat-checkbox
								(change)="updateTransportKind($event, TransportKind.OWN_TRANSPORT)"
								value="ownTransport"
								[(ngModel)]="selectedTransport().ownTransport"
								>Dojazd własny</mat-checkbox
							>
						</div>
					</div>
				}

				@if (search().show && (selectedTransport().coach || selectedTransport().plane)) {
					<app-search
						[placeholder]="search()?.options?.placeholder"
						(searchUpdated)="searchingValue$.next($event)"
					></app-search>
				}

				@if (stopsMode) {
					@if (selectedTransport().coach) {
						@let busStops = busStops$ | async;

						<p class="text-mainColor font-bold">Przystanki</p>

						@if (busStops?.length > 0) {
							<app-multi-choice
								[_options]="busStops"
								[_selected]="selected"
								[enableScroll]="multiChoiceEnableScroll"
								[constrainScrollHeight]="multiChoiceConstrainHeight"
								[style.--multi-choice-form-container-height]="
									multiChoiceConstrainHeight ? multiChoiceHeight : null
								"
								(filterValue)="filtersActions($event)"
							></app-multi-choice>
						} @else {
							<p class="text-mainColor">Brak przystanków</p>
						}
					}

					@if (selectedTransport().plane) {
						@let airports = airports$ | async;

						<p class="text-mainColor font-bold">Lotniska</p>

						@if (airports?.length > 0) {
							<app-multi-choice
								[_options]="airports"
								[_selected]="selected"
								[enableScroll]="multiChoiceEnableScroll"
								[constrainScrollHeight]="multiChoiceConstrainHeight"
								[style.--multi-choice-form-container-height]="
									multiChoiceConstrainHeight ? multiChoiceHeight : null
								"
								(filterValue)="filtersActions($event)"
							></app-multi-choice>
						} @else {
							<p class="text-mainColor">Brak lotnisk</p>
						}
					}
				} @else {
					<app-multi-choice
						[_options]="options$ | async"
						[_selected]="selected"
						[enableScroll]="multiChoiceEnableScroll"
						[constrainScrollHeight]="multiChoiceConstrainHeight"
						[style.--multi-choice-form-container-height]="
							multiChoiceConstrainHeight ? multiChoiceHeight : null
						"
						(filterValue)="filtersActions($event)"
					></app-multi-choice>
				}
			</div>
		}

		@if (type === DropdownType.COUNTER) {
			<app-top-search-counter
				[rows]="rows$ | async"
				[counters]="counters$ | async"
				(rowValueChange)="filtersActions($event)"
			></app-top-search-counter>
		}

		@if (type === DropdownType.DATE) {
			<app-top-search-date-picker
				[offersDateRange]="offersDateRange$ | async"
				[selectedDateRange]="selectedDateRange$ | async"
				(selectedDateRangeChange)="filtersActions($event)"
			></app-top-search-date-picker>
		}

		@if (type === DropdownType.PRICE) {
			@let priceRange = priceRange$ | async;
			<app-price-filter
				[min]="priceRange?.min"
				[max]="priceRange?.max"
				(rangeChanged)="priceRangeChanged($event)"
				class="flex justify-center"
			></app-price-filter>
		}
	</div>

	@if (showFooterButtons) {
		<div
			class="buttons flex flex-row justify-between items-center border-mainColorLight bg-white py-2 max-md:border-t"
		>
			<button class="w-1/2 hover:underline !text-mainColor" (click)="clearFilterValue()">Wyczyść</button>
			<button (click)="closeDropdown()" class="submit-btn">Wybierz</button>
		</div>
	}
</div>
